import { config } from '@/config';
import useUserPlan from '@/hooks/useUserPlan';
import { isLoadingSelector } from '@/redux/slice/loading';
import { useSelector } from 'react-redux';

export const useCustomUserIdClarity = (currentPage: string) => {
  const { shop } = config;
  const { currentPlan } = useUserPlan();
  const isLoadingGeneralSetting = useSelector(isLoadingSelector);
  const callCreateCustomerId = () => {
    if (typeof window === 'undefined' || !window.clarity || !shop || !currentPlan || isLoadingGeneralSetting) return;
    window.clarity('identify', shop, currentPlan, currentPage, shop);
  };

  callCreateCustomerId();
};
